import styled from 'styled-components';
import { H3, H2 } from 'components/typography';

export const EmptyContainer = styled.div`
  align-items: top;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0;
  margin-bottom: 20px;
  height: 200px;
  width: 100%;
`;

export const Content = styled.div`
  padding: 20px;
  margin: 0 10px;
`;

export const Title = styled(H3)`
  display: flex;
  justify-content: center;
  margin-top: 0;
  font-weight: 600;
  font-size: 22px;
`;

export const SubTitle = styled(H2)`
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  font-weight: 300;
`;
